import React, { Component } from "react";
import PropTypes from "prop-types";
import ContentPageNavigationButton from "./ContentPageNavigationButton";

class ContentPagePostsBlock extends Component {
  render() {
    const { prevPost, nextPost } = this.props;
    return (
      <div className="mt-auto mb-0 d-flex justify-content-between">
        {prevPost && <ContentPageNavigationButton post={prevPost} />}
        {nextPost && <ContentPageNavigationButton post={nextPost} />}
      </div>
    );
  }
}

ContentPagePostsBlock.propTypes = {};

export default ContentPagePostsBlock;
